import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class ReportLoader extends Loader {}

export const reportLoader = new ReportLoader({
  service: SERVICES.report,
})
